// <!-- LEGAL REVIEW REQUIRED --> Template only. Placeholders are in LEGAL_TODO.md.
import React from 'react';
import { LegalList, LegalPage } from '../../components/ui';
import { COMPANY, CONTACT_EMAIL, LEGAL_UPDATED, MAILING_ADDRESS, REFUND_WINDOW, RETURN_WINDOW, WARRANTY_PERIOD } from '../../lib/legal';

const SECTIONS = [
  {
    title: '1. Cancel Before Shipping',
    body: 'You can cancel your pre-order for a full refund any time before your glasses ship. You do not need to give a reason. This applies to both non-prescription and prescription orders.',
  },
  {
    title: '2. How to Request a Refund',
    body: `Email ${CONTACT_EMAIL} from the address you used to order and tell us you would like to cancel.`,
  },
  {
    title: '3. How Fast Refunds Are Processed',
    body: `We issue refunds within ${REFUND_WINDOW} of your request, to your original payment method. Your bank may take additional time to post the refund to your account.`,
  },
  {
    title: '4. If We Change the Price or Delay Shipping',
    body: 'If the price of your order would change, or your estimated ship window slips, we will notify you and you can cancel for a full refund. See the pre-order section of our Terms of Service for details.',
  },
  {
    title: '5. Returns After Delivery',
    body: `You can return non-prescription glasses within ${RETURN_WINDOW} of delivery for a full refund of the purchase price, as long as they are in perfect condition: no scratches, damage, or signs of wear, with all original accessories and packaging. Email ${CONTACT_EMAIL} to start a return and we will tell you where to send them. You pay return shipping unless the glasses arrived defective or we sent the wrong item. We issue your refund within ${REFUND_WINDOW} of receiving and inspecting the return.`,
  },
  {
    title: '6. Prescription Orders',
    body: 'Prescription orders cannot be returned after delivery, because the lenses are made to your prescription. You can still cancel for a full refund any time before your order ships. If your lenses do not match the prescription you gave us, or your glasses arrive defective, we will remake or repair them at no cost under the warranty below.',
  },
  {
    title: '7. Limited Warranty',
    body: (
      <LegalList
        items={[
          `Length: ${WARRANTY_PERIOD} from delivery, for the original buyer.`,
          'What it covers: defects in materials and workmanship under normal use, including the frame, lenses, electronics, and battery. A battery that holds less than 70% of its original charge during the warranty period counts as a defect.',
          'What it does not cover: accidental damage such as drops or crushing, water or other liquid damage, normal wear such as scratches, damage from repairs or changes not made by us, loss or theft, and changes to your prescription after delivery.',
          `How to make a claim: email ${CONTACT_EMAIL} with your order number and a description of the problem. We may ask for photos or a short video.`,
          'What we do: if the problem is covered, we repair your glasses, replace them with the same or an equivalent model, or, if neither is possible, refund the purchase price. We pay shipping both ways for covered claims. Repaired or replaced glasses are covered for the rest of the original warranty or 90 days, whichever is longer.',
          'This warranty gives you specific legal rights, and you may also have other rights that vary from state to state. Nothing in this policy limits any warranty or other right you have under the law.',
        ]}
      />
    ),
  },
  {
    title: '8. Contact',
    body: `${COMPANY}, ${MAILING_ADDRESS}. Email: ${CONTACT_EMAIL}.`,
  },
];

const Refunds = () => <LegalPage title="Refunds and Cancellation" updated={LEGAL_UPDATED} sections={SECTIONS} />;

export default Refunds;
